import { render, staticRenderFns } from "./FornecedoresVsComprador.vue?vue&type=template&id=497293de"
import script from "./FornecedoresVsComprador.vue?vue&type=script&lang=js"
export * from "./FornecedoresVsComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports